import React from 'react';
import { LdgGraphExplorer } from '../content/ldgGraph';
export function LdgGraphPage() {
  return <div className="h-full flex flex-col bg-white" data-id="element-7191" data-mp="2z75udhjgam62">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 bg-white flex-shrink-0" data-id="element-7192" data-mp="346s6fnnjlwda">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-7193" data-mp="344p7uf8bquwy">
          Leerpad Graaf (LDG)
        </h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-7194" data-mp="38zlbydqu58qf">
          Interactieve visualisatie van alle vraagfamilies en hun onderlinge
          afhankelijkheden.
        </p>
      </div>

      {/* Graph Explorer - takes full remaining height */}
      <div className="flex-1 relative overflow-hidden" data-id="element-7195" data-mp="3mwqfo732tvii">
        <LdgGraphExplorer data-id="element-7196" data-mp="3mv6uq36h6wae" />
      </div>
    </div>;
}